// Simple map-based cache, keyed directly by CacheKey
// Use for shortlived, finite execution contexts like map ops

import {MultiSetEntry, Cache, CacheKey} from './types';

export class MapCache implements Cache {
  private readonly map: Map<CacheKey, any>;

  constructor() {
    this.map = new Map<CacheKey, any>();
  }

  get(key: CacheKey): Promise<any> {
    return Promise.resolve(this.map.get(key));
  }

  getMulti(keys: CacheKey[]): Promise<any[]> {
    return Promise.all(keys.map(k => this.get(k)));
  }

  set(key: CacheKey, value: any): Promise<boolean> {
    return Promise.resolve(!!this.map.set(key, value));
  }

  async setMulti(entries: Array<MultiSetEntry<CacheKey>>): Promise<boolean> {
    const result = await Promise.all(
      entries.map(e => this.set(e.key, e.value))
    );
    return result.every(r => !!r);
  }

  del(key: CacheKey): Promise<void> {
    this.map.delete(key);
    return Promise.resolve();
  }

  has(key: CacheKey): Promise<boolean> {
    return Promise.resolve(this.map.has(key));
  }
  hasMulti(keys: CacheKey[]): Promise<boolean[]> {
    return Promise.all(keys.map(k => this.has(k)));
  }

  reset(): Promise<void> {
    return Promise.resolve(this.map.clear());
  }
}
